import { setPlannerCellField } from '../State/plannerCell'

export default (key, value) => (dispatch) => {

  dispatch(setPlannerCellField({ key, value }))
  
}
